export default __webpack_public_path__ + "static/aizada-4df76c87dc38f14d1fe1e8b2cbbc584c.jpg";